import React from 'react';

import { Button } from '@wwe-portal/ui/components/button';
import { type OfferCardProps } from '@wwe-portal/ui/features/offer';
import type { SubscriptionTier } from '@wwe-portal/entities/subscription.type';

import { ExclusiveOfferBanner } from '../exclusive-items/exclusive-offer-banner';

import MilestoneRewardDetails from './milestone-reward-details';

export interface MissionRewardCardProps {
  tier?: SubscriptionTier;
  title?: string;
  description?: string;
  detailsDescription?: string;
  timer?: string;
  rewardList?: string[];
  offerData?: OfferCardProps;
  loading?: boolean;
  missionType?: number;
  isBlocked?: boolean;
}
export default function MissionRewardCard({
  tier,
  description,
  timer,
  rewardList,
  detailsDescription,
  offerData,
  onClick,
  onReferSubscription,
  isBlocked,
  loading = false,
  title,
  missionType,
}: MissionRewardCardProps & {
  onClick: (data: {
    tier: SubscriptionTier;
    offerData: OfferCardProps;
  }) => void;
  onReferSubscription: () => void;
  isBlocked: boolean;
}) {
  const getActionBtn = () => {
    if (!offerData) return null;
    if (isBlocked) {
      return (
        <Button
          className="bg-goldtier m-0 my-[10px] h-[46px] w-[100%] text-base"
          onClick={onReferSubscription}
        >
          Go To Subscription
        </Button>
      );
    }
    return (
      <Button
        className="m-0 my-[10px] h-[46px] w-[100%] text-base"
        loading={loading}
        onClick={() => tier && onClick({ offerData, tier })}
      >
        {loading ? (
          'Processing'
        ) : (
          <div className="flex items-center justify-center gap-x-1 text-white">
            {offerData.price}
          </div>
        )}
      </Button>
    );
  };
  return (
    <MilestoneRewardDetails
      actionBtn={getActionBtn()}
      cardBanner={
        offerData ? (
          <ExclusiveOfferBanner {...offerData} className="h-[140px]" />
        ) : undefined
      }
      description={description ?? ''}
      detailsDescription={detailsDescription ?? ''}
      missionType={missionType}
      quantity={offerData?.quantity}
      rewardList={rewardList ?? []}
      tier={tier}
      timer={timer}
      title={title}
    />
  );
}
